import { applyTokens } from "../../../utilities/applyTokens.js";
const table = (tokens) => {
    const { core: { spacing }, component: { table: { small, medium, large, header, cell, row, footer }, }, } = tokens;
    return {
        MuiTableRow: {
            styleOverrides: {
                root: Object.assign(Object.assign({}, applyTokens(row.default)), { "&.Mui-selected": applyTokens(row.selected) }),
                hover: applyTokens(row.hover),
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: Object.assign(Object.assign(Object.assign({ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, applyTokens(cell)), applyTokens(large.cell)), { "&.MuiTableCell-head, &.MuiTableCell-noBackgroundHead": Object.assign({}, applyTokens(large.header)) }),
                sizeMedium: Object.assign(Object.assign({}, applyTokens(medium.cell)), { "&.MuiTableCell-head, &.MuiTableCell-noBackgroundHead": Object.assign({}, applyTokens(medium.header)) }),
                sizeSmall: Object.assign(Object.assign({}, applyTokens(small.cell)), { "&.MuiTableCell-head, &.MuiTableCell-noBackgroundHead": Object.assign({}, applyTokens(small.header)) }),
                head: Object.assign(Object.assign({ verticalAlign: "revert", position: "relative" }, applyTokens(header)), { "&:first-of-type": applyTokens(header.first), "&:last-of-type": applyTokens(header.last) }),
                noBackgroundHead: Object.assign(Object.assign({}, applyTokens(header)), { backgroundColor: row.default.backgroundColor.value, "&:first-of-type": applyTokens(header.first), "&:last-of-type": applyTokens(header.last) }),
            },
        },
        MuiTablePagination: {
            defaultProps: {
                SelectProps: {
                    variant: "outlined",
                },
            },
            styleOverrides: {
                root: applyTokens(footer.container),
                displayedRows: {
                    display: "none",
                },
                select: {
                    width: footer.rowsPerPages.width.value,
                    textAlignLast: "left",
                },
                selectRoot: {
                    margin: spacing[0].value,
                },
                selectLabel: applyTokens(footer.label),
                spacer: {
                    display: "none",
                },
                toolbar: ({ theme }) => ({
                    gap: footer.container.gap.value,
                    [theme.breakpoints.up("sm")]: {
                        paddingInline: spacing[0].value,
                    },
                    [theme.breakpoints.up("md")]: {
                        paddingInline: spacing[0].value,
                    },
                    [theme.breakpoints.up("lg")]: {
                        paddingInline: spacing[0].value,
                    },
                }),
            },
        },
    };
};
export default table;
//# sourceMappingURL=table.js.map